var _AlertTriangle, _Refresh;
import AlertTriangle from '@crehana/compass.icons.outline/AlertTriangle';
import Refresh from '@crehana/compass.icons.outline/Refresh';
import { EmptyState } from '@crehana/compass.ui/empty-state';
import { Button, Container } from '@crehana/compass.ui/v2';
import { useAddI18nLocales, useSharedComponentsTranslation } from "./i18n";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var ErrorContent = function ErrorContent(_ref) {
  var onRetry = _ref.onRetry;
  useAddI18nLocales();
  var _useSharedComponentsT = useSharedComponentsTranslation(),
    t = _useSharedComponentsT.t;
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsx(EmptyState, {
      icon: _AlertTriangle || (_AlertTriangle = /*#__PURE__*/_jsx(AlertTriangle, {
        size: 24,
        className: "tw-text-neutral-light-600"
      })),
      className: "!tw-p-0",
      title: t('LABEL_HANA_ERROR_FETCH_TITLE'),
      description: t('LABEL_HANA_ERROR_FETCH_DESCRIPTION'),
      primaryAction: /*#__PURE__*/_jsxs(Button, {
        type: "button",
        variant: "primary",
        size: "md",
        onClick: function onClick() {
          return onRetry === null || onRetry === void 0 ? void 0 : onRetry();
        },
        children: [_Refresh || (_Refresh = /*#__PURE__*/_jsx(Refresh, {
          size: 20,
          className: "tw-text-inherit"
        })), t('LABEL_HANA_ERROR_FETCH_BUTTON')]
      })
    })
  });
};